import React from "react";
import { Link } from "react-router-dom";
import s from "./LandingFooter.module.scss";

const columns = [
  {
    title: "About us",
    links: [
      { to: "/history", label: "History" },
      { to: "/aboutMctac", label: "What is MCTAC" },
      { to: "/aboutHub", label: "About Digital Transit HUB" },
      { to: "/regionalRepresentatives", label: "Regional Representatives" },
    ],
  },
  {
    title: "Committee",
    links: [
      { to: "/committee", label: "Advisory Committee" },
      { to: "/committee", label: "Members of the Board" },
      { to: "/news", label: "News & Events" },
    ],
  },
  {
    title: "Digital Transit HUB",
    links: [
      { to: "/signIn", label: "Sign in" },
      { to: "/register", label: "Register" },
    ],
  },
];

const LandingFooter = () => {
  return (
    <footer className={s.footer}>
      <div className={s.inner}>
        <div className={s.brand}>
          <img src="/images/moldovas_gerb.png" alt="MCTAC" className={s.logo} />
          <div>
            <div className={s.name}>ANV-MCTAC</div>
            <div className={s.full_name}>
              Middle Corridor Transit Advisory Committee
            </div>
          </div>
          {/* verbatim from the What is MCTAC page */}
          <p className={s.about}>
            An international community, operating as a non-governmental
            organization, established by the National Customs Association of the
            Republic of Moldova.
          </p>
        </div>
        {columns.map((col) => (
          <div className={s.column} key={col.title}>
            <div className={s.title}>{col.title}</div>
            {col.links.map((l) => (
              <Link to={l.to} className={s.link} key={l.label}>
                {l.label}
              </Link>
            ))}
          </div>
        ))}
      </div>
      <div className={s.bottom}>
        <div className={s.bottom_inner}>
          © {new Date().getFullYear()} Middle Corridor Transit Advisory
          Committee. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
